import { Grid } from '@mui/material'
import InputCustom from '../../../atoms/input/InputCustom'
import DateCustom from '../../../atoms/input/DateCustom'
import SelectCustom from '../../../atoms/select/SelectCustom'
import styles from '../index.module.scss'

const BasicDetailTab = ({ userDetails, setUserDetails, options }) => {
	return (
		<Grid container spacing={1.5}>
			<Grid size={{ xs: 12, md: 12 }}>
				<div className={styles.formField}>
					<label htmlFor="PartyName" className={styles.label}>
						Party Name
					</label>
					<InputCustom
						type="text"
						name="partyName"
						id="partyName"
						placeholder="Enter party name"
						className=""
					/>
				</div>
			</Grid>
			<Grid size={{ xs: 12, md: 12 }}>
				<div className={styles.formField}>
					<label htmlFor="amount" className={styles.label}>
						Amount
					</label>
					<InputCustom
						type="number"
						name="amount"
						id="amount"
						placeholder="Enter amount"
						className=""
					/>
				</div>
			</Grid>
			<Grid size={{ xs: 12, md: 12 }}>
				<div className={styles.formField}>
					<label htmlFor="DueDate" className={styles.label}>
						Due Date
					</label>
					<DateCustom
						name="date"
						setDataFunction={setUserDetails}
						data={userDetails}
						value={userDetails.date}
					/>
				</div>
			</Grid>
			<Grid size={{ xs: 12, sm: 12 }}>
				<div className={styles.formField}>
					<label htmlFor="Status" className={styles.label}>
						Status
					</label>
					<SelectCustom label="Select user" options={options} />
				</div>
			</Grid>
		</Grid>
	)
}
export default BasicDetailTab
